import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Door Sensor Icon Style 01 - Sensor Door (Material Symbol)
 * - isOn = true (open): 紅色開門
 * - isOn = false (closed): 綠色關門
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:sensor_door
 */
export const Style01_Door: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-red-500' : 'text-green-500';
  const iconName = isOn ? 'door_open' : 'door_front';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' 1, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      {iconName}
    </span>
  );
};

export default Style01_Door;
